export default [
  {
    name: 'Referral Tracking Visibility',
    info: 'Unlimited access to all your referrals.',
    icon: require('@/assets/svg/paper-plane.svg')
  },
  // {
  //   name: 'Unlimited SMS',
  //   info: 'Convenient chat for efficient scheduling.',
  //   icon: require('@/assets/svg/sms-dualtone.svg'),
  //   isSpecialistOnly: true
  // },
  // {
  //   name: 'Patient Referral via Text',
  //   info: 'Send a copy of the referral to the patient.',
  //   icon: require('@/assets/svg/sms-unanswered.svg')
  // },
  // {
  //   name: 'Print & Download',
  //   info: 'Save, print and download all documents.',
  //   icon: require('@/assets/svg/download-dualtone.svg')
  // },
  // {
  //   name: 'Print, Download, Copy',
  //   info: 'Save, print and download all documents.',
  //   icon: require('@/assets/svg/download-dualtone.svg')
  // },
  // {
  //   name: 'Print & Download',
  //   info: 'Optimized print view and one-click PDF export.',
  //   icon: require('@/assets/svg/integration-dualtone.svg')
  // },
  // {
  //   name: 'Copy',
  //   info: 'Copy all referral data, including attachments.',
  //   icon: require('@/assets/svg/integration-dualtone.svg')
  // },
  {
    name: 'Insights',
    info: 'Friendly reports with actionable data with no limits.',
    icon: require('@/assets/svg/insights-dualtone.svg')
  },
  // {
  //   name: 'Enhanced Reach', //Promoted office
  //   info: 'Be promoted to all offices within 30 miles.',
  //   icon: require('@/assets/svg/featured-dualtone.svg'),
  //   isSpecialistOnly: true
  // },
  {
    name: 'Unlimited storage',
    info: 'You referrals and data are stored and accessible indefinitely.',
    icon: require('@/assets/svg/insurance-dualtone.svg')
  },
  {
    name: 'Personalized Referral Form',
    info: 'A direct public link to your online referral form. Customizable with your own logo.',
    icon: require('@/assets/svg/paper-plane-dualtone.svg'),
    isSpecialistOnly: true
  },
  {
    name: 'Premium Support',
    info: 'Priority and dedicated phone support at your disposable.',
    icon: require('@/assets/svg/paper-plane-dualtone.svg'),
    isSpecialistOnly: true
  },
  {
    name: 'Premium Access for Referring GPs',
    info: 'Premium access granted to your referring GPs.',
    icon: require('@/assets/svg/featured-dualtone.svg'),
    isSpecialistOnly: true,
    planMeta: ['invites']
  },
  // {
  //   name: 'Custom Branding',
  //   info: 'Put your logo on your referrals.',
  //   icon: require('@/assets/svg/insurance-dualtone.svg')
  // },
  // {
  //   name: 'Integration',
  //   info: 'Auto populate referrals and more.',
  //   icon: require('@/assets/svg/integration-dualtone.svg'),
  //   planMeta: ['integration']
  // },
  
]
